module.exports = __webpack_public_path__ + "images/protecta.6cde9635298c593d06e3579035c67a08.png";